export default {
  FivePercent: 5,
  TenPercent: 10,
};
